module.exports = __webpack_public_path__ + "img/logo-libu-app.ea1fd10a.png";